import { environment } from 'src/environments/environment';
import { Component, OnInit , Inject} from '@angular/core';
import { KnowledgeSectionService } from '../knowledge-section.service';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { NgxSpinnerService } from "ngx-spinner";
import { PageScrollService } from 'ngx-page-scroll-core';
import { DOCUMENT } from '@angular/common';



@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
  itemsPerPage = 6;
  maxSize = 6;
  totalItems : any=0;
  page: number = 1;
  news : any;
  imageBasePath = environment.imgUrl;
  totalPages = 0;
  showPagination:boolean = false

  constructor(private service: KnowledgeSectionService,
    private toastr: ToastrService, private sanitized: DomSanitizer,
    private spinner: NgxSpinnerService,
    private pageScrollService: PageScrollService, 
    @Inject(DOCUMENT) private document: any,
    private titleService:Title
    ) { }

  ngOnInit(): void {
    this.titleService.setTitle("News | Social App Hub");
    this.loadPage();
  }

  loadPage(): void {
    this.spinner.show();    
    this.service.getNews(this.page).subscribe((data: any) => {
      this.spinner.hide();
      if (data.status === 200) {
        this.showPagination = true;
        this.news = data.body.newsdata;
        this.totalItems = data.body.news_count;
        this.totalPages = (this.totalItems%this.itemsPerPage) == 0 ? (this.totalItems/this.itemsPerPage): (Math.trunc(this.totalItems/this.itemsPerPage) + 1)
      }
    }, err => {
      this.spinner.hide();
      this.toastr.error(err.error.message, '');
    });
  }

  transform(value) {
    if (value) {
      let data:any = value.replace(/<.*?>/g, '');            
      return data.substring(0,200) + '....'
    }
  }
  pageChanged(event: any): void {
    this.page = event.page;
    this.pageScrolling('#scrollingToTop')
    this.loadPage();
  }
  pageScrolling(nameOfClass){
    this.pageScrollService.scroll({
      document: this.document,
      scrollTarget: nameOfClass
    });
  }

  newsLinkClick(data1){
    this.service.clickNews(data1['_id']).subscribe((data: any) => {
      this.spinner.hide();
      if (data.status === 200) {
      }
    }, err => {
      this.spinner.hide();
    });
  }
}
